module.exports = __webpack_public_path__ + "img/potato.d5a1137d.jpg";